<template>
  <v-dialog v-model="ui.mockModal.show" max-width="600px">
    <v-card class="pa-4">
      <v-card-title class="text-h5 primary--text">
        <v-icon color="primary" class="mr-2">mdi-information</v-icon>
        API/DB 호출 알림 (데모)
      </v-card-title>
      <v-card-text>
        <p class="mb-4">데모 버전에서는 실제 서버 호출 대신 원래 요청 정보를 표시합니다.</p>

        <v-table density="compact" class="mb-4 border">
          <tbody>
            <tr>
              <th class="text-left" style="width: 120px">URL</th>
              <td>{{ ui.mockModal.url }}</td>
            </tr>
            <tr>
              <th class="text-left">Method</th>
              <td>
                <v-chip
                  size="small"
                  :color="getMethodColor(ui.mockModal.method)"
                  text-color="white"
                >
                  {{ ui.mockModal.method?.toUpperCase() }}
                </v-chip>
              </td>
            </tr>
          </tbody>
        </v-table>

        <div v-if="ui.mockModal.data" class="mt-4">
          <div class="text-subtitle-2 mb-1">전송 데이터 (Payload):</div>
          <pre
            class="pa-3 bg-grey-lighten-4 rounded text-caption"
            style="max-height: 200px; overflow-y: auto"
            >{{ JSON.stringify(ui.mockModal.data, null, 2) }}</pre
          >
        </div>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" variant="elevated" @click="ui.closeMockModal()">
          확인
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script setup>
import { uiStore } from "@/store/UiStore";

const ui = uiStore();

const getMethodColor = (method) => {
  switch (method?.toLowerCase()) {
    case "get":
      return "info";
    case "post":
      return "success";
    case "put":
      return "warning";
    case "delete":
      return "error";
    default:
      return "grey";
  }
};
</script>

<style scoped>
pre {
  white-space: pre-wrap;
  word-break: break-all;
}
</style>
